import { Controller, useFormContext } from "react-hook-form";

import { CustomInvokeCodeEditor } from "src/aiNode/CustomInvokeCodeEditor";
import { FieldErrors } from "src/api/types";
import { Card } from "src/base-components/Card";
import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";
import { FormItem } from "src/base-components/FormItem";
import { AgentNodeData } from "src/constants/NodeDataTypes";

type Props = {
  immutable: boolean;
  isReactive: boolean;
  runFieldErrors?: FieldErrors;
};

export const AgentPromptEditor: React.FC<Props> = ({
  immutable,
  isReactive,
  runFieldErrors,
}) => {
  const { control, watch } = useFormContext<AgentNodeData>();
  const filesId = watch("files.id");
  const filesErrorMessage = runFieldErrors?.[filesId];

  return (
    <Card className="w-full pb-4 pt-4">
      <FormItem>
        <FormItem.Label
          className="mb-2"
          description="Optional instructions for the agent invocation."
        >
          Instructions
        </FormItem.Label>
        <Controller
          control={control}
          name="prompt"
          render={({ field }) => (
            <div className="h-80">
              <CustomInvokeCodeEditor
                immutable={immutable}
                isReactive={isReactive}
                placeholder="e.g. You are a helpful assistant. Please analyze the following data and provide insights."
                value={field.value as string}
                onChange={field.onChange}
              />
            </div>
          )}
        />
      </FormItem>
      <div className="mt-4 space-y-2" data-loc="agent-node-files">
        <div>
          <h3 className="text-gray-800 font-inter-semibold-13px">
            Include files
          </h3>
          <span className="text-gray-500 font-inter-normal-12px">
            Include a list of file IDs to be sent to the agent
          </span>
        </div>
        <Controller
          control={control}
          name="files.expression"
          render={({ field }) => (
            <AutocompleteCodeInput
              dataLoc="agent-node-files-input"
              disabled={immutable}
              error={filesErrorMessage}
              placeholder="data.file_ids"
              value={field.value}
              onChange={field.onChange}
            />
          )}
        />
      </div>
    </Card>
  );
};
